<div class="top-summary">
  <div class="left">
    <div class="totals-holder">
      <div class="totals">
        <ng-container *ngIf="eventStatus">
          <div class="total-label bold">Event Status:</div>
          <div class="total-amount bold">{{ eventStatus }}</div>
        </ng-container>
        <div class="total-label">Number of Attendees:</div>
        <joi-input class="total-amount"
          [(model)]="budget.attendees" 
          [fixedWidth]="true"
          [placeholder]="readOnly ? '' : 'Number...'"
          [outlined]="!readOnly"
          [displayValue]="budget.attendees ? (budget.attendees | prettyNumbers:0) : null"
          [allowableCharacters]="'0123456789.'"
          [disabled]="readOnly"
          (joiChange)="updateAttendees()"
        ></joi-input>
        <div class="total-label">Budget Currency:</div>
        <div class="total-amount">{{ budget.currency }}</div>
        <div class="total-label">Show Totals as:</div>
        <dropdown class="total-amount"
          [selections]="taxOptions" 
          [selected]="taxOptions | findById: budget?.summaryTaxInclusive ? 'inclusive' : 'exclusive'" 
          [disableDropdown]="readOnly"
          [null_text]="'Select tax type'"
          (select)="updateTaxOption($event.id)"
        ></dropdown>
        <div class="total-label">Revenue:</div>
        <div class="total-amount">{{ budgetSummary.revenueSubtotal ? (budgetSummary.revenueSubtotal | prettyNumbers) : '' }}</div>
        <div class="total-label">Other Revenue:</div>
        <joi-input class="total-amount" 
          [(model)]="budget.otherRevenues[0].amount" 
          [fixedWidth]="true"
          [placeholder]="readOnly ? '' : '00.00'"
          [allowableCharacters]="'0123456789.'"
          [outlined]="!readOnly"
          [displayValue]="!budget.otherRevenues[0].amount ? null : budget.otherRevenues[0].amount | prettyNumbers"
          [disabled]="readOnly"
          (joiChange)="updateOtherRevenue()"
        ></joi-input>
        <div class="total-label">Other Revenue Description:</div>
        <joi-input class="total-amount"
          [(model)]="budget.otherRevenues[0].description" 
          [placeholder]="readOnly ? '' : 'Description...'" 
          (joiChange)="budgetUpdated.emit()"
          [disabled]="readOnly"
          [type]="'textarea'" 
          [outlined]="!readOnly"
          [autoSelect]="false" 
          [returnable]="true"
        ></joi-input>
      </div>
    </div>
    <div class="total-box revenue">
      <div class="line">
        <div class="label bold">Total Revenue</div>
        <div class="amount bold">{{ budgetSummary.totalRevenue | prettyNumbers }}</div>
      </div>
      <ng-container *ngIf="!!budget.attendees">
        <div class="line">
          <div class="label">Revenue per head</div>
          <div class="amount">{{ budgetSummary.totalRevenue / (budget.attendees || 0) | prettyNumbers }}</div>
        </div>
      </ng-container>
    </div>
    <div class="total-box costs">
      <div class="line">
        <div class="label bold">Total Costs</div>
        <div class="amount bold">{{ budgetSummary.totalCosts | prettyNumbers }}</div>
      </div>
      <ng-container *ngIf="!!budget.attendees">
        <div class="line">
          <div class="label">Costs per head</div>
          <div class="amount">{{ budgetSummary.totalCosts / (budget.attendees || 0) | prettyNumbers }}</div>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="!!budgetSummary.totalRevenue">
      <div class="total-box margin">
        <div class="line">
          <div class="label bold">Margin</div>
          <div class="amount bold">{{ budgetSummary.totalRevenue - budgetSummary.totalCosts | prettyNumbers }}</div>
        </div>
        <div class="line">
          <div class="label">Margin %</div>
          <div class="amount">{{ (!budgetSummary.totalRevenue ? 0 : (budgetSummary.totalRevenue - budgetSummary.totalCosts) / budgetSummary.totalRevenue) | prettyNumbers:2:100 }}%</div>
        </div>
      </div>
    </ng-container>

  </div>
  <div class="pies desktop">
    <div class="pie-holder" *ngIf="budgetSummary?.revenueArcs?.length">
      <h3>Revenue</h3>
      <arc [arcData]="budgetSummary.revenueArcs"></arc>
    </div>
    <div class="pie-holder" *ngIf="budgetSummary?.costsArcs?.length">
      <h3>Costs</h3>
      <arc [arcData]="budgetSummary.costsArcs"></arc>
    </div>
    
    
  </div>
</div>
<ng-container *ngIf="cashFlowGrid?.length">
  <h2 class="desktop">Cash Flow</h2>
  <budget-grid class="desktop"
    [readOnly]="true" 
    [columns]="cashFlowColumns" 
    [rows]="cashFlowGrid"
  ></budget-grid>
</ng-container>


